import {
  UpYunPreMissionModel,
  CommonUploadModel,
  UpYunUploadSuccessModel
} from 'src/model/CommonModels';
import {
  get,
  extend,
  isFunction
} from 'lodash';

function getError(action, option, xhr) {
  let msg;
  if (xhr.response) {
    msg = `${xhr.response.error || xhr.response}`;
  } else if (xhr.responseText) {
    msg = `${xhr.responseText}`;
  } else {
    msg = `fail to post ${action} ${xhr.status}`;
  }

  const err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  const text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function getXhr() {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  return new XMLHttpRequest();
}

function bindXhrEvent(xhr, option, action) {
  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr));
    }

    option.onSuccess(getBody(xhr));
  };
}

function xhrSend(xhr, option, action) {
  xhr.open('post', action, true);

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }
  const formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(key => {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  const headers = option.headers || {};

  for (let item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }
  xhr.send(formData);
}


export default function (options) {
  let uploadQuery = {};
  let xhr = getXhr();

  let res = null;
  if (options.data && '_target' in options.data && options.data._target === 'local') {
    // 只往本地服务器上传的文件类型
    res = Promise.reject();
  } else {
    let postData = extend({
      files: [
        {
          name: options.file.name,
          type: options.file.type,
          size: options.file.size,
          lastModified: options.file.lastModified
        }
      ]
    }, options.data);

    if (!options.file.type) {
      res = import('mime-types').then(function(mimetype) {
        postData.files[0].type = mimetype.default.lookup(options.file.name);
        return postData;
      });
    } else {
      res = Promise.resolve(postData);
    }

    res = res.then((post) => UpYunPreMissionModel.getInstance().execute(post));
  }

  res.then(function(result){
    let {
      upload_url,
      list
    } = result;
    uploadQuery['uuid'] = get(list, '0.uuid');
    let bindOptions = extend({}, options);
    if ( isFunction(bindOptions.onSuccess) ) {
      let onSuccessFn = bindOptions.onSuccess;
      bindOptions.onSuccess = function(result){
        if (result.code === 200) {
          // 同步信息到服务器中
          UpYunUploadSuccessModel
            .getInstance(true)
            .execute(extend({}, uploadQuery, result))
            .then((result)=>{
              onSuccessFn(result);
            }).catch((err)=>{
            if (err instanceof Error) {
              throw err;
            }
            bindOptions.onError(err);
          });
        } else {
          bindOptions.onError(result);
        }
      }
    }

    bindXhrEvent(xhr, bindOptions, upload_url);
    xhrSend(xhr, {
      headers: {},
      data: {
        authorization: get(list, '0.authorization'),
        policy: get(list, '0.policy')
      },
      filename: 'file',
      file: options.file
    }, upload_url);
  }).catch(function () {
    let commonUpload = CommonUploadModel.getInstance().getConfig();
    let uploadUrl =  commonUpload.domain + '/' + commonUpload.ns + '/' + commonUpload.url;
    if (commonUpload.domain.substr(-1) === '/') {
      uploadUrl =  '/' + commonUpload.ns + '/' + commonUpload.url;
    }
    let bindOptions = extend({}, options);
    if ( isFunction(bindOptions.onSuccess) ) {
      let onSuccessFn = bindOptions.onSuccess;
      bindOptions.onSuccess = function(result){
        if (result.errno === 0) {
          onSuccessFn(result.data);
        } else {
          bindOptions.onError(result);
        }
      }
    }
    bindXhrEvent(xhr, bindOptions, uploadUrl);
    xhrSend(xhr, extend({
      data: options.data,
      withCredentials: true,
      filename: 'files[]',
      file: options.file
    }), uploadUrl);
  });

  return xhr;
}
